// FAQ for the /agents page. Shared by the page (client/web/Legal.jsx) and the
// server-rendered FAQPage structured data (lib/routes/new-home.js), so the
// two can't drift. Answers are bullet lists (website copy rule).
module.exports = [
  {
    q: 'How do payment and confirmation work?',
    a: [
      'Your assistant prepares a checkout link for the exact product and recipient',
      'You open the link, check the details and pay on mobiletopup.com',
      'An assistant can never pay or complete a purchase on its own',
    ],
  },
  {
    q: 'Does it cost extra?',
    a: [
      'No — the same prices and payment fees as buying on the website',
    ],
  },
  {
    q: 'What information do I need?',
    a: [
      'Top-ups: the recipient phone number with country code',
      'Every order: your email, for the receipt and your account',
      'eSIMs and gift cards: no phone number needed',
    ],
  },
  {
    q: 'What does MobileTopup store?',
    a: [
      'Your agent key, stored only in encrypted (hashed) form',
      'Each request your assistant makes: the tool used, its inputs, the assistant’s name and IP address',
      'Checkout links your assistant creates — deleted after 90 days if no order was placed',
      'Request records are deleted after 90 days',
    ],
  },
  {
    q: 'Does my AI provider see or train on my messages?',
    a: [
      'MobileTopup only receives the tool calls your assistant sends, not your conversation',
      'How your conversation is stored or used is set by your AI provider — check its privacy settings',
    ],
  },
  {
    q: 'How do I disconnect an assistant?',
    a: [
      'Connected with Claude or ChatGPT sign-in: press Disconnect on this page',
      'Using a key: generate a new key on this page — the old key stops working immediately',
    ],
  },
];
